import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-gold/15 bg-navy-900" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 grid gap-10 md:grid-cols-4">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <img src="/logo.png" alt="Levi One" className="h-12 w-12 rounded-full ring-1 ring-gold/40" />
          <span className="text-white font-semibold tracking-[0.2em]">
            LEVI <span className="text-gold">ONE</span>
          </span>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          Conseil, étude et accompagnement des entreprises dans leur transition énergétique.
        </p>
      </div>

      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold mb-4">Navigation</h4>
        <ul className="space-y-2 text-sm">
          <li><Link data-testid="footer-link-home" to="/" className="text-slate-400 hover:text-gold transition-colors">Accueil</Link></li>
          <li><Link data-testid="footer-link-services" to="/services" className="text-slate-400 hover:text-gold transition-colors">Services</Link></li>
          <li><Link data-testid="footer-link-who" to="/qui-sommes-nous" className="text-slate-400 hover:text-gold transition-colors">Qui sommes-nous ?</Link></li>
          <li><Link data-testid="footer-link-fiches" to="/fiches-cee" className="text-slate-400 hover:text-gold transition-colors">Fiches CEE</Link></li>
          <li><Link data-testid="footer-link-contact" to="/contact" className="text-slate-400 hover:text-gold transition-colors">Contact</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold mb-4">Expertises</h4>
        <ul className="space-y-2 text-sm text-slate-400">
          <li>Certificats d'Économies d'Énergie (CEE)</li>
          <li>Rénovation énergétique</li>
          <li>Décret Tertiaire 2030</li>
          <li>Mise en relation partenaires</li>
        </ul>
      </div>

      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-gold mb-4">Contact</h4>
        <ul className="space-y-3 text-sm text-slate-400">
          <li className="flex items-center gap-2"><Mail size={15} className="text-gold" /> <a href="mailto:contact@levi-one.fr" data-testid="footer-email-link" className="hover:text-gold transition-colors">contact@levi-one.fr</a></li>
          <li className="flex items-center gap-2"><Phone size={15} className="text-gold" /> <a href="tel:+33766653736" data-testid="footer-phone-link" className="hover:text-gold transition-colors">07 66 65 37 36</a></li>
          <li className="flex items-center gap-2"><MapPin size={15} className="text-gold" /> 45 Allée Arthur Rimbaud, 95350 Saint-Brice-sous-Forêt</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-gold/10 py-5 px-6 flex flex-col sm:flex-row items-center justify-between gap-2 max-w-7xl mx-auto text-xs text-slate-500">
      <p>© 2026 Levi One — Conseil • Étude • Accompagnement. Tous droits réservés.</p>
      <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-gold transition-colors">
        Mentions légales
      </Link>
    </div>
  </footer>
);
